import Route from 'cio/routes/base';
import { singularize } from 'ember-inflector';

export default class ListRoute extends Route {
  setupController(controller) {
    let { type } = this.paramsFor('data-index.type');
    controller.set('type', singularize(type));
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.setProperties({
        search: '',
        page: 1,
      });
    }
  }
}
